// Cart page: line updates via /cart/change.js then section re-render (api-cart-items), quantity select/stepper,
// free-shipping threshold from the rosae.free_shipping_thresholds shop metafield (Liquid computes it for
// every country whose rule is in the cart currency; only CA/HK need the market rate here), terms gate
// (no persisted attribute), recently viewed.
const $ = (s, r = document) => r.querySelector(s);
const page = document.querySelector('.cart[data-cart-page]') || document.querySelector('[data-cart-drawer] [data-cart-page]');
if (page) {
  const holder = $('[data-items-holder]', page);
  const sectionUrl = `${window.rosae.routes.cart}?section_id=api-cart-items`;
  const showError = (title, msg) => { const box = $('[data-cart-errors]', page); if (!box) return; $('[data-error-message]', box).textContent = `${title} — ${msg}`; box.hidden = false; };
  $('[data-cart-error-close]', page)?.addEventListener('click', () => { $('[data-cart-errors]', page).hidden = true; });

  async function rebuild() {
    const html = new DOMParser().parseFromString(await (await fetch(sectionUrl)).text(), 'text/html');
    holder.innerHTML = $('[data-api-line-items]', html)?.innerHTML || '';
    $('[data-cart-price-holder]', page)?.replaceWith($('[data-cart-price-holder]', html));
    const fs = $('[data-free-shipping-holder]', page); if (fs) fs.innerHTML = $('[data-api-free-shipping]', html)?.innerHTML || '';
    const count = Number($('[data-api-item-count]', html)?.textContent || 0);
    page.classList.toggle('is-empty', count === 0);
    document.dispatchEvent(new CustomEvent('rosae:cart:updated', { detail: { item_count: count } }));
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cartCount: count } }));
    freeShipping();
  }
  async function change(line, quantity, itemEl) {
    page.classList.add('is-loading'); itemEl?.classList.add('is-loading');
    try {
      const res = await fetch(window.rosae.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      const data = await res.json();
      if (!res.ok || data.errors) throw new Error(data.description || data.errors || data.message);
      const item = data.items?.[line - 1];
      if (item && quantity > 0 && item.quantity < quantity) showError(itemEl?.dataset.itemTitle || '', window.rosae.strings.stockLimit);
      await rebuild();
    } catch (ex) { showError(itemEl?.dataset.itemTitle || '', ex.message); await rebuild(); }
    finally { page.classList.remove('is-loading'); }
  }
  holder.addEventListener('change', (e) => {
    const item = e.target.closest('[data-item]'); const line = Number(item?.dataset.itemIndex);
    if (e.target.matches('[data-quantity-select]')) {
      const v = Number(e.target.value);
      if (v === 10) { e.target.hidden = true; const c = $('.cart__quantity-counter', item); c.hidden = false; $('input', c).focus(); }
      else change(line, v, item);
    }
    if (e.target.matches('input[name="updates[]"]')) change(line, Number(e.target.value), item);
  });
  holder.addEventListener('click', (e) => {
    const item = e.target.closest('[data-item]'); const line = Number(item?.dataset.itemIndex);
    const btn = e.target.closest('button[name="increase"], button[name="decrease"]');
    if (btn) { const inp = $('input[name="updates[]"]', item); inp.value = Math.max(0, Number(inp.value) + (btn.name === 'increase' ? 1 : -1)); inp.dispatchEvent(new Event('change', { bubbles: true })); }
    const rm = e.target.closest('[data-item-remove]');
    if (rm) { e.preventDefault(); change(line, 0, item); }
  });
  document.addEventListener('theme:cart:refresh', rebuild);

  function freeShipping() {
    const el = $('[data-free-shipping]', page); if (!el) return;
    const total = Number(el.dataset.total);
    let limit = Number(el.dataset.threshold);
    if (el.hasAttribute('data-needs-conversion')) {
      // CA and HK only: they present in CAD/HKD against a rule denominated in EUR, the shop currency,
      // so Shopify.currency.rate — the same market rate that presents every other price on the page —
      // is the right multiplier. Round UP: we may under-promise by a rounding unit, and can never
      // promise free shipping that checkout then refuses.
      limit = Math.ceil(limit * Number(window.Shopify?.currency?.rate || 1));
      const msg = $('.free-shipping__message', el);
      if (msg) {
        const amount = new Intl.NumberFormat(window.rosae.locale, { style: 'currency', currency: el.dataset.cartCurrency }).format(Math.max(limit - total, 0) / 100);
        msg.innerHTML = (el.dataset.messageTemplate || '').replace('[amount]', amount);
      }
      el.hidden = false;
    }
    el.classList.toggle('is-success', limit <= 0 || total >= limit);
    const bar = $('[data-progress-bar]', el); if (bar) bar.value = limit > 0 ? Math.min(100, Math.round((total / limit) * 100)) : 100;
  }
  freeShipping();

  const terms = $('[data-cart-acceptance-checkbox]', page); const buttons = $('[data-cart-checkout-buttons]', page); const termsErr = $('[data-terms-error-message]', page);
  if (terms && buttons) {
    const sync = () => { const on = terms.checked; buttons.disabled = !on; buttons.querySelectorAll('button').forEach((b) => { b.disabled = !on; b.setAttribute('aria-disabled', String(!on)); }); if (on) termsErr.hidden = true; };
    terms.addEventListener('change', sync); sync();
    $('.cart__checkout', page)?.addEventListener('click', (e) => { if (!terms.checked && e.target.closest('[data-cart-checkout-buttons]')) { e.preventDefault(); termsErr.hidden = false; } });
    $('[data-cart-form]', page)?.addEventListener('submit', (e) => { if (!terms.checked) { e.preventDefault(); termsErr.hidden = false; terms.focus(); } });
  }
}
if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', class extends HTMLElement {
  async connectedCallback() {
    const m = document.cookie.match(/(?:^|; )shopify_recently_viewed=([^;]*)/);
    const handles = m ? decodeURIComponent(m[1]).split(' ').filter((h) => h && h !== this.dataset.exclude).slice(0, Number(this.dataset.limit || 2)) : [];
    // A handle that no longer resolves answers 200, not 404 (api-product-card guards that server-side
    // now). Keep a client check too, and test a FIELD rather than the element: an empty card is still
    // an element, so filter(Boolean) alone let a blank tile through. data-url is empty for a nil product.
    const cards = await Promise.all(handles.map(async (h) => { try { const html = new DOMParser().parseFromString(await (await fetch(this.dataset.url.replace('HANDLE', h))).text(), 'text/html'); const card = html.querySelector('[data-card]')?.firstElementChild; return card?.dataset.url ? card : null; } catch (e) { return null; } }));
    const found = cards.filter(Boolean); if (found.length) { this.replaceChildren(...found); this.hidden = false; }
  }
});
